<script>
import DOMUtils from '@/utils/DOMUtils'

export default
{
    name: 'app-branding',

    props:
    {
    },

    created ()
    {
        window.addEventListener('scroll', this.onWindowScroll, { passive: true })
    },

    render () 
    {
        const isRegularMobile = DOMUtils.getMatchingMediaName() == 'mobile' && !DOMUtils.isLargeMobile()

        return (
            <div class='app-branding'>
                <div id='top-background' />
                <inline-svg id='wave' src={require('@/assets/img/wave-shape.svg')} />
                <div id='mockups'>
                    <img src={require(`@/assets/img/iphone-x-mockup-${isRegularMobile ? 'horizontal' : 'vertical'}.png`)} />
                </div>
                <h1 id='app-description'>
                    <b>Ma Ville</b> est une solution qui permet à votre ville de s'équiper d'une application
                    <b> <vue-typer text={['moderne', 'intuitive', 'élégante', 'multi-plateforme', 'à moindre coût']}></vue-typer></b>.
                </h1>
                <div id='down-arrow' on-click={this.onDownArrowClicked}>
                    <inline-svg  src={require('@/assets/img/left-arrow.svg')} v-show={this.isDownArrowShown} />
                </div>
            </div>
        )
    },

    mounted ()
    {
    },

    destroyed ()
    {
        window.removeEventListener('scroll', this.onWindowScroll)
    },

    data () 
    {
        return {
            isDownArrowShown: true
        }
    },

    computed:
    {
    },

    methods:
    {
        onWindowScroll ()
        {
            this.isDownArrowShown = window.scrollY < 100
        },

        onDownArrowClicked ()
        {
            const media = DOMUtils.getMatchingMediaName()
            const top = window.innerHeight * (media == 'desktop' ? 0.9 : 1.2)

            window.scrollTo({ left: 0, top, behavior: 'smooth' })
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.app-branding
{
    .vue-typer
    {
        white-space: pre;

        .custom.char
        {
            color: inherit;
        }
        .custom.caret
        {
            background-color: white;
        }
    }

    #top-background
    {
        position: absolute;
        background: var(--theme-accent-color);
        top: 0;
        width: 100%;
        height: calc(60vh + 9.8vw);
    }

    #mockups
    {
        position: absolute;
        top: 45vh;
        width: 100vw;
        height: 100vw;
        left: 0;

        .OnLargeMobile({
            top: 40vh;
            height: 120vw;
        });

        .OnTablet({
            top: 57vh;
            width: 50vw;
            height: 50vw;
            left: (100% - 50vw) / 2;
        });

        .OnDesktop({
            top: 25vh;
            left: (55% - 40vw) / 2;
            width: 40vw;
            height: 40vw;
        });

        img
        {
            animation: hover 3s cubic-bezier(0.4, 0, 1, 1) infinite;
            object-fit: cover;
            width: 100%;
            height: 100%;
            margin-top: -7vh;
        }
    }

    #app-description
    {
        position: absolute;
        color: #c9c5fd;
        font-size: 7vw;
        right: 10vw;
        width: 80vw;
        top: 5vh;

        .OnTablet({
            font-size: 4.5vh;
            top: 13vh;
        });

        .OnDesktop({
            font-size: 2.5vw;
            right: 11vw;
            width: 43vw;
            top: 30vh;
        });

        b
        {
            color: white;
        }
    }

    #down-arrow
    {
        --size: 8vw;
        .OnTablet({ --size: 6vw; });
        .OnDesktop({ --size: 3vw; });
        .OnLarge({ --size: 2.5vw; });

        position: absolute;
        fill: var(--theme-accent-color);
        left: calc(50vw - var(--size) / 2);
        animation: bounce 3s linear infinite;
        animation-delay: 10s;
        cursor: pointer;
        width: var(--size);
        height: var(--size);
        bottom: 3vh;

        .OnDesktop({
            bottom: 5vh;
        });
        
        svg
        {
            transform: rotate(-90deg);
        }
    }
    
    #wave
    {
        position: absolute;
        width: 100%;
        top: 60vh;
        fill: white;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/AppBranding.vue